<script setup lang="ts">
import { useAccountStore } from "@/stores/account";
import { isAPLink } from "@/utils/client";
import { onMounted } from "vue";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import LanguagesModal from '@/components/Modal/LanguagesModal.vue';
import { isStarNest } from "@/utils/starnest";
const accountStore = useAccountStore();
const languagesList = ref([
  { label: "English", value: "en-US" },
  { label: "简体中文", value: "zh-CN" },
]);
const showLanguages = ref<Boolean>(false);
const isShowLanguageModal = ref<boolean>(false)
const clickTimes = ref(0);
const time = ref<any>(0);
const scrollChanged = ref<boolean>(false);
const { t,locale } = useI18n({ useScope: "global" });

const props = defineProps({
  bgColor:{
    type:String,
    default:'#070B14'
  }
})

// const setLanguage = (data: string) => {
//   locale.value = data;
//   if (data === 'zh-CN') {
//     window.document.title = 'Mana 刮刮乐'
//   }else{
//     window.document.title = 'Mana Lottery'
//   }
//   showLanguages.value = !showLanguages.value;
// };

const connectWallet = () => {
  accountStore.connectWallet;
};

onMounted(() => {
  // window.addEventListener("scroll", function () {
  //   // 在这里编写需要执行的代码
  //   const scrollTop = document.documentElement.scrollTop;
  //   scrollChanged.value = scrollTop > 44;
  // });
  // console.log("---8-13 02:00");
  setTimeout(() => {
    accountStore.connectWallet
  }, 500);
});

const clickLogo = () => {
  clickTimes.value++;
  sessionStorage.setItem("clickLogoTImes", `${clickTimes.value}`);
  if (clickTimes.value >= 7) {
    var vConsole = new window.VConsole();
  }
};

const accountName = computed(() => {
  return accountStore.getUserInfo.name;
});
</script>

<template>
  <div class="header flex-row-between-center" :style="`background-color:${props.bgColor}`">
    <div class="wallet flex-row-start-center" @click="clickLogo" v-if="isStarNest"> 
      <i class="icon"></i> <span class="address">{{ accountName ? accountName : $t("Connect Wallet") }}</span>
    </div>
    <div v-else></div>
    <i class="locale" @click="isShowLanguageModal = true"></i>
    <LanguagesModal v-model:isShow="isShowLanguageModal"></LanguagesModal>
  </div>
</template>

<style lang="scss" scoped>
.header{
  padding: 10px 0;
  .wallet{
    display: flex;
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 10px;
    border: 1px solid #303342;
    font-size: 12px;
    color: #9C9CAA;
    .icon{
      width: 16px;
      height: 16px;
      background: url(../assets/star/wallet.svg);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .locale{
    width: 24px;
    height: 24px;
    background: url(../assets/star/locale.svg);
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
  }
}
</style>
